import * as React from 'react';
import { Link } from 'react-router-dom';
import Person from 'src/entities/Person';
import User from 'src/entities/User';

interface Props {
  activeProfile?: Person;
  user?: User;
  logout(): void;
  changeInvestorProfile(): void;
}

class LoggedUserNavToolsComponent extends React.PureComponent<Props> {
  public render(): React.ReactNode {

    const completePercent = this.props.activeProfile && this.props.activeProfile.percentCompleted ?
      this.props.activeProfile.percentCompleted : 0;

    const name = this.props.activeProfile ? this.props.activeProfile.displayName : ' ';
    const initials = name![0] + (name!.split(/[^A-Za-z]/)[1] ?
      name!.split(/[^A-Za-z]/)[1][0] : '');

    return [
      (
        <li key="progress">
          <Link to="/mi-cuenta/perfil" style={{ 'padding': 0 }}>
            <p className="c-orange">
              <strong>
                Perfil completado: {completePercent} %
              </strong>
            </p>
            <div
              className="progress-bar-border-orange"
              data-container="body"
              data-html="true"
              data-trigger="hover"
              data-toggle="popover"
              data-placement="bottom"
            >
              <div className="progress-bar-orange" style={{ width: completePercent + '%' }} />
            </div>
          </Link>
        </li>
      ),
      (
        <li
          key="my-menu"
          className="dropdown"
        >
          <a
            className="dropdown-toggle btn-menu btn-circle-user"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="circle">
              {initials}
            </span>
            <span className="caret arrow-down" />
          </a>
          <ul className="dropdown-menu">
            <li>
              <Link
                to="/mi-cuenta/perfil"
                className="btn-menu"
              >
                Mi cuenta
              </Link>
            </li>
            <li
              role="separator"
              className="divider"
            />
            <li>
              <Link
                to="/mi-cartera"
                className="btn-menu"
              >
                Mi cartera
              </Link>
            </li>
            <li
              role="separator"
              className="divider"
            />
            {
              this.props.user && this.props.user.hasCompanies ?
                [
                  <li key="link">
                    <Link
                      to="/mi-empresa"
                      className="btn-menu"
                    >
                      Mi empresa
                    </Link>
                  </li>,
                  <li
                    key="separator"
                    role="separator"
                    className="divider"
                  />
                ]
                :
                null
            }
            <li onClick={() => this.props.changeInvestorProfile()}>
              <div
                className="btn-menu"
              >
                Cambiar perfil
              </div>
            </li>
            <li
              role="separator"
              className="divider"
            />
            <li onClick={this.props.logout}>
              <Link
                to="/"
                className="btn-menu"
              >
                Cerrar sesión
              </Link>
            </li>
          </ul>
        </li>
      )
    ];
  }
}

export default LoggedUserNavToolsComponent;



// WEBPACK FOOTER //
// ./src/modules/commons/header/partials/LoggedUserNavTools.component.tsx